<template>
  <ion-page v-if="computedFilters && computedFilters.length > 0">
    <ion-content>
      <FormDataTableFilters
        ref="form-data-table-filters"
        :filters="computedFilters"
        :filtersModels="filtersModels"
        :search="search"
        @searching="search.value = $event"
        @filtersChange="filtersModels = $event"
      />
      
      <ion-card v-for="(item, ix) in computedItems.slice(0,maxLoadedItems)" :key="ix" 
          :class="{ 
            'invalid-item': item.invalidItem, 'warned-item': !item.invalidItem && item.warnedItem,
            'info-item': !item.invalidItem && !item.warnedItem && infoSA7(item) }"
          :style="{ margin: '10px 15px 10px 10px' }">
        <ion-card-header @click="showDetails(item)" :style="{ padding: '8px' }">
          <ion-list class="ion-no-padding ion-no-margin">
            <ion-item class="ion-no-padding ion-no-margin">
              <ion-img 
                v-if="item[imageHeader.value] && item[imageHeader.value].length > 0" 
                :src="item[imageHeader.value][0]"
                :style="{width: '15%', marginRight: '10px'}"
                slot="start"
                ></ion-img>
              <ion-card-subtitle> {{ item[titleHeader.value] }} - {{item[subTitleHeader.value]}}</ion-card-subtitle>
              <ion-icon slot="end" :icon="(item.show) ? chevronUp : chevronDown"></ion-icon>
            </ion-item>
          </ion-list>
         
          <ion-list v-if="!item.show" :style="{padding: '0'}" class="ion-no-padding ion-no-margin">
            <ion-item v-for="(header, index) in allHeaders" :key="index"  class="ion-no-padding ion-no-margin">
              <ion-label :style="{margin: 0}">
                <h6 :style="{color: 'gray'}">
                  {{header.text}}:
                  <span :style="{color: isDark ? 'white' : 'black'}">{{ getFormatValue(header, item) }}</span>
                </h6>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-card-header>

        <template v-if="item.show">
          <ion-card-content 
            :class="item.invalidItem ? 'ion-no-padding invalid-header' : 'ion-no-padding'">

            <ion-card-subtitle v-if="!this.readonly" :style="{margin: '0 15px 5px', color: 'darkgray'}">Formulário:</ion-card-subtitle>
            <ion-list v-if="!this.readonly" :style="{padding: '0'}">
              <template v-for="(field, iy) in computedEditableHeadersData" :key="iy">
                <ion-item lines="none" v-show="!field.hide" 
                  :class="item.invalidItem && item.invalidField.header.value === field.value ? 'invalid-header box' : 'inherit box'"
                  :style="{'--min-height': 0}">
                  <section :style="{width: '100%', margin: '2px 0'}">
                    <ion-label position="floating" :style="{margin: '5px 8px 0 0', fontSize: '20px'}">{{ field.text }}</ion-label>
                    <div 
                      v-show="editing != `${ix}-${iy}`" 
                      @click="editingField({ix,iy})" 
                      :style="{height: '40px', lineHeight: '40px', boxSizing: 'content-box', fontSize: '22px', color: isDark ? 'white' : 'black'}"
                    >
                      {{getFormatValue(field, item)}}
                    </div>
                    <ion-input
                      v-show="editing == `${ix}-${iy}`"
                      :ref="`form-data-table__input--${ix}-${iy}`"
                      :color="item.invalidItem && item.invalidField.header.value === field.value ? 'danger' : 'undefined'"
                      :type="field.input ? field.input.type : ''"
                      @click="$event.target.select()"
                      v-model="item[field.value]"
                      :disabled="readonly || (typeof field.editable == 'function') ? !field.editable({item, formMaster}) : !field.editable"
                      @change="blurField({item, header: field, value: $event.target.value})"
                      @keydown.enter="editingField()"
                      @ionBlur="editingField()"
                      :style="{height: '40px', fontSize: '22px'}"
                    />
                  </section>
                  <section slot="end" :style="{margin: '15px 0 15px'}">
                    <ion-button 
                      v-if="field.input?.type == 'number'" 
                      color="danger" 
                      @click="item[field.value] = item[field.value] - 1; blurField({item, header: field, value: item[field.value]})"
                      size="small"
                      :style="{width: '50px', height: '50px', marginRight: '5px'}">
                      <ion-icon :icon="removeOutline"></ion-icon>
                    </ion-button>
                    <ion-button 
                      v-if="field.input?.type == 'number'" 
                      color="primary" 
                      @click="item[field.value] = item[field.value] + 1; blurField({item, header: field, value: item[field.value]})"
                      size="small"
                      :style="{width: '50px', height: '50px', marginRight: '5px'}">
                      <ion-icon :icon="addOutline"></ion-icon>
                    </ion-button>
                  </section>
                </ion-item>
              </template>
            </ion-list>

            <ion-card-subtitle :style="{margin: '15px 15px -5px', color: 'darkgray'}">Detalhes do item:</ion-card-subtitle>
            <ion-list :style="{padding: '0'}">
              <ion-item v-for="(field, index) in computedReadonlyHeadersData" :key="index">
                <ion-label :style="{margin: 0}">
                  <h6 :style="{color: 'gray'}">
                    {{field.text}}:
                    <ion-grid v-if="field.type == 'images'">
                      <ion-row>
                        <ion-col :size="(item[field.value].length > 1) ? 6 : 12" v-for="src in item[field.value]" :key="src">
                          <ion-img 
                            :src="src"
                          ></ion-img>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                    <span v-else :style="{color: isDark ? 'white' : 'black'}">{{item[field.value]}}</span>
                  </h6>
                </ion-label>
              </ion-item>
            </ion-list>

            <ion-button :color="item.invalidItem ? 'danger' : 'primary'"
              v-if="!readonly" @click="showDetails(item)" expand="block">
              <ion-icon :icon="checkmarkOutline"></ion-icon> OK {{item.invalidItem ? '(Item com erros)' : ''}}
            </ion-button>
          </ion-card-content>
        </template>

        <ion-card-subtitle v-if="item.invalidItem" :style="{ padding: '0 8px 1px' }">
          <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
          <template v-if="item.errorMessages && item.errorMessages.length > 0">
            <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="danger" v-for="(error, idx, key) in item.errorMessages" :key="key" v-html="`${error}`"></ion-text>
          </template>
        </ion-card-subtitle>

        <ion-card-subtitle v-if="item.warnedItem" :style="{ padding: '0 8px 1px' }">
          <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
          <template v-if="item.warnMessages && item.warnMessages.length > 0">
            <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="warning" v-for="(warn, idx, key) in item.warnMessages" :key="key" v-html="`${warn}`"></ion-text>
          </template>
        </ion-card-subtitle>
      </ion-card>

      <!-- Loading -->
      <ion-grid v-if="loading" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label>Buscando itens</ion-label>
            <br/>
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- No Data -->
      <ion-grid v-else-if="computedItems && computedItems.length == 0" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label color="danger" v-if="isSearched">A pesquisa por "<strong>{{ search.value }}</strong>" não retornou registros, confira os filtros selecionados.</ion-label>
            <ion-label color="danger" v-else-if="isFiltered">Os filtros selecionados não retornaram registros.</ion-label>
            <ion-label color="danger" v-else-if="SA7Filtered">A amarração cliente x produtos não retornou registros.</ion-label>
            <ion-label color="danger" v-else>Sem registros.</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>


      <ion-infinite-scroll
        @ionInfinite="loadData($event)"
        threshold="100px"
        id="infinite-scroll"
        ref="infiniteScroll"
        :disabled="isDisabled">
        <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Buscando mais dados...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script>
import store from "../store";
import FormDataTableFilters from './FormDataTableFilters.vue'
import {  
  chevronDown, 
  chevronUp, 
  close,
  checkmarkOutline,
  addOutline,
  removeOutline
} from "ionicons/icons";
import {
  IonCard,
  IonContent,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonList,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonLabel,
  IonInput,
  // IonFooter,
  IonButton,
  IonSpinner,
  IonIcon,
  IonInfiniteScroll,
  IonPage,
  IonInfiniteScrollContent,
  IonImg
  // IonModal,
} from "@ionic/vue";

export default {
  name: "FormDataTable",
  components: {
    IonContent,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonText,
    // IonSearchbar,
    IonList,
    IonItem,
    IonGrid,
    IonRow,
    IonCol,
    IonLabel,
    IonInput,
    // IonToggle,
    // IonCol,
    IonButton,
    IonSpinner,
    IonIcon,
    // IonProgressBar,
    // IonFooter,
    IonPage,
    FormDataTableFilters,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonImg
    // IonModal,
  },
  emits: ["validated", "setTotalize"],
  props: {
    headers: Array,
    formMaster: Object,
    props: Object,
    items: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "teal",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    exportXls: {
      type: Boolean,
      default: true,
    },
    xlsxName: {
      type: String,
      default: "itens",
    },
    filterItems: {
      type: Function,
      default: (item) => item,
    },
    emptyResItems: {
      type: Boolean,
      default: false
    },
    SA7off: {
      type: Boolean,
      default: false,
    },
    user: Object,
    userRules: Array
  },
  methods: {
    getModel() {
      const itemsProcessed = this.computedItemsProcessed.map(item => {
        this.computedHeadersData.forEach(header => {
          if (header.type == 'integer') {
            item[header.value] = parseInt(item[header.value])
          } else if (header.type == 'float') {
            item[header.value] = parseFloat(item[header.value])
          }
        })
        return item
      })
      return itemsProcessed
    },
    editingField({ix, iy} = {}) {
      if (ix == undefined || iy == undefined) return this.editing = null
      this.editing = `${ix}-${iy}`
      this.$nextTick(() => {
        this.getInput(ix,iy).setFocus()
      });
    },
    getInput(ix,iy) {
      return this.$refs[`form-data-table__input--${ix}-${iy}`][0].$el
    },
    dispatchClearFilters() {
      this.$refs['form-data-table-filters'].clearFilters()
    },
    getTable() {
      return this.computedItemsProcessed.map(item => {
        let itemTable = {}
        for (let header of this.computedHeadersData) {
          itemTable[header.value] = this.getFormatValue(header, item)
        }
        return itemTable
      })
    },
    showDetails(item) {
      item.show = !item.show;
    },
    validate() {
      const allValidations = this.computedItemsProcessed.filter(this.filterItems).every(item => 
        this.computedHeadersData.filter(header => header.validation).every(header => 
          header.validation.every((f) => {
            const validated = f(item);
            if (typeof validated == "string") {
              this.errorMessages.push(validated)
              return false;
            } else {
              return validated;
            }
          })
        )
      )

      return allValidations;
    },
    getTotalize() {
      return this.totalize;
    },
    getMaskedValue({header, item}) {
      const value = item[header.value] ? item[header.value] : header.default ? header.default : null
      if (typeof value === 'null' || typeof value === 'NaN') return ''

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const prefix = header.prefix ? header.prefix + " " : "";
      const suffix = header.suffix ? " " + header.suffix : "";

      return prefix + maskedValue + suffix;
    },
    async fetchFiltersCollections() {
      await Promise.all(
        this.filters.map(async (filter) => {
          if (filter.method && filter.method.collectionName) {
            const response = await this.get({
              collection: filter.method.collectionName,
              register: filter.method.collectionName,
              orderBy: "indice",
            });
            filter.method.values = response.map(
              (item) => item[filter.method.collectionField]
            );
            return response;
          }
          return Promise.resolve();
        })
      );
    },
    blurField({ item, value, header }) {
      this.process({ item, value, header }) 
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },
    process({ item, value, header }) {
      this.setValue({item, header, value})

      this.warnField({header, item})
      
      if (!this.validateField({header, item})) 
        return

      // Os headers/atributos a serem usados como busca não devem incluir o próprio elemento que está sendo alterado.
      const headers = this.computedHeadersData.filter(h => h.value != header.value)

      // Array com os dependentes diretos do header, elimina a possibilidade do elemento ser dependente *direto* dele mesmo devido ao filter.
      const directDependentAttributes = this.getDependentAttributes(header, headers)

      // Headers a serem computados respeitando a ordem de precedência da menor posição do array pra maior.
      const dependencyChain = this.getDependencyChain(directDependentAttributes, headers)

      // for of para respeitar a ordem do array `dependencyChain`, que é a ordem de prioridade.
      for (const dependentHeaders of dependencyChain) {
        dependentHeaders.forEach(header => {
          this.computeItem({item, header})
        })
      }
    },
    /**
     * Retorna um array de headers que dependem *diretamente* do `header` passado no primeiro parâmetro
     */
    getDependentAttributes (header, headers) {
      return headers.filter(h => h.dependents && h.dependents.includes(header.value))
    },
    /**
     * Retorna uma cadeia de headers que são dependentes dos headers passados no primeiro argumento.
     * A ordem dos elementos no array indicam o grau de dependência dos headers.
     */
    getDependencyChain(dependents, headers, dependencyChain = []) {
      if (dependents.length == 0)
        return dependencyChain

      const filteredHeaders = headers.filter(h => !dependents.includes(h))
      const newDependents = dependents
        .map(h => this.getDependentAttributes(h, filteredHeaders))
        .reduce((acc,arr) => [...acc, ...arr.filter(el => !acc.includes(el))], [])

      return this.getDependencyChain(newDependents, filteredHeaders, [...dependencyChain, dependents])
    },
    computeItems(){
      // if(this.props.tableSA7) { 
      //   this.filtersModels['filterSA7'] = this.props.tableSA7 
      // }

      this.itemsProcessed = this.items.map(item => {
        this.computedHeadersData.forEach(header => {
          item[header.value] = item[header.value] != undefined ? 
                                item[header.value] : 
                                'default' in header ? 
                                  header.default : null
        })

        const computeFirstHeaders = this.headers.filter(h => h.computeFirst)

        computeFirstHeaders.forEach((header) => 
          this.computeItem({item, header})
        )
        return {...item, invalidItem: false}
      })
      this.loadingItems = false
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },

    computeItem({item, header}) {
      if (!header || !header.dependents || !header.computed) return 
      const itemDependent = this.getDependentsItem({item, header})
      const computedValue = header.computed({item: itemDependent}) 
      this.setValue({item, header, value: computedValue})
    },

    getDependentsItem({header, item}) {
      return header.dependents.reduce((acc, dependent) => {
        return { ...acc, [dependent]: item[dependent] }
      }, {})
    },

    infoSA7(item){
      return item.A7_YINCLUIR && this.filterItems(item)
    },

    setValue({value, item, header}, { validate = true, set = true, mask = true, verbose = true } = { validate: true, set: true, mask: true, verbose: true }) {

      if (value == null) {
        if (verbose)
          console.warn(`${header.value} "value" is null`)

        // text = ""
        item[header.value] = value

        if (header.required) {
          this.validated = false
          this.errorMessages.push('Campo obrigatório')
        }
        return
      } 

      const valueBkp = value
      if (header.type == 'integer') {
        
        value = parseInt(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          value = 0
          // return
        }
      } else if (header.type == 'float') {
        value = parseFloat(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          // return
          value = 0
        } 
        value = this.fixPrecision(value, header.precisionValue)
      }

      if (set) {
        item[header.value] = header.set ? header.set({value, item}, this.formMaster) : value
      } else {
        item[header.value] = value
      }

      // const text = this.getMaskedValue({header, item})

      // console.info('text', text);
      // this.validated = validate ? this.validate() : true

      // altera no item original somente se estiver validado
      // if (this.validated)
      //   this.row.item[this.name] = item[header.value]
    },

    validateField({item, header}) {
      const { validation = [] } = header
      if (validation && validation.length > 0) item.errorMessages = []
      return validation.every(f => {
        const validated = f(item)
        if (typeof validated == 'string') {
          item.invalidField = { header }
          item.invalidItem = true
          item.errorMessages.push(validated)
          return false
        } else {
          item.invalidField = validated ? { header } : null
          item.invalidItem = !validated
          return validated
        }
      })

    },

    warnField({header, item}) {
      const { warning = [] } = header
      if (warning && warning.length > 0) item.warnMessages = []
      for (const f of warning) {
        const warned = f(item)
        if (typeof warned == 'string') {
          item.warnedField = { header }
          item.warnedItem = true
          item.warnMessages.push(warned)
        } else {
          item.warnedField = warned ? { header } : null
          item.warnedItem = warned
        }
      }
    },

    fixPrecision(value, precision = 4) {
      if (!Number.isFinite(value)) {
        return NaN
      }

      let fixed = value
      if (!Number.isInteger(fixed)) {
        let [integerPart, mantissa] = fixed.toString().split('.')
        
        if (mantissa && mantissa.length > precision) {
          const balanceDigit = parseInt(mantissa[precision])
          if (balanceDigit >= 5) {
            let fix = (parseInt(`${integerPart}${mantissa.slice(0, precision)}`) + 1).toString()
            fix = fix.padStart(integerPart.length+precision, '0')
            
            integerPart = fix.slice(0, fix.length - precision)
            mantissa = fix.slice(-precision)
          } else {
            mantissa = mantissa.slice(0, precision)
          }
          fixed = parseFloat(integerPart + '.' + mantissa)
        }
      }

      return fixed
    },
    getFormatValue(header, item) {
      let value = item[header.value]
      const prefix = header.prefix
        ? header.prefix + ' '
        : ''

      if (typeof value === 'undefined' || value === null) {
        if (typeof header.default !== 'undefined') {
          value = header.default
        } else if (header.type == 'float' || header.type == 'integer') {
          value = 0
        } else {
          value = ''
        }
      }

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const suffix = header.suffix
        ? ' ' + header.suffix
        : ''

      return prefix + maskedValue + suffix
    },
    // pushData() {
    //   const max = this.loadedItems.length + 20;
    //   const min = max - 20;
    //   console.info('this.loadedItems', this.loadedItems);
    //   console.info('max', max);
    //   console.info('min', min);
    //   for (let i = min; i < max; i++) {
    //     this.loadedItems.push(this.computedItems[i]);
    //   }
    //   this.showItems = true
    // },
    // toggleInfiniteScroll() {
    //   this.isDisabled = !this.isDisabled;
    // },
    loadData(event) {
      this.maxLoadedItems += 20
      // setTimeout(() => {
      //   this.pushData();
        if (event) {
          event.target.complete()
        }

      //   // App logic to determine if all data is loaded
      //   // and disable the infinite scroll
        if (this.maxLoadedItems >= this.computedItems.length) {
        // if (this.loadedItems.length === this.computedItems.length) {
          if (event) {
            event.target.disabled = true;
          }
        }
      // }, 500);
    },
    // searchEnabled($event) {
    //   this.showItems = false
    //   this.search.value = $event
    //   this.loadedItems = []
    //   this.loadData()
    // }
  },
  computed: {
    loading() { return !this.computedItems || (!this.isFiltered && !this.computedItems.length > 0 && !this.emptyResItems) },
    isDark() { return store.$isDark },
    computedHeadersData(){
      return this.headersData
    },
    computedEditableHeadersData(){
      return this.computedHeadersData.filter(x => x.editable && !x.hide)
    },
    computedReadonlyHeadersData(){
      return this.computedHeadersData.filter(x => ((typeof x.hide == 'function') ? !x.hide({readonly: this.readonly, formMaster: this.formMaster, user: this.user, userRules: this.userRules}) : !x.hide) && (!x.editable || this.readonly))
    },
    computedItemsProcessed() {
      return this.itemsProcessed
    },
    headersMobile() {
      return this.computedHeadersData.filter((h) => h.mobile && !h.mobile.justTotalize && !h.hide);
    },
    computedFilters() {
      const filters = this.computedHeadersData.filter(x => x.filterable === true)
      filters.forEach(el => {
        const ixH = this.computedHeadersData.findIndex(x => x.value === el.value)
        switch (el.filterType) {
          case 'switch':
            this.headersData[ixH].filter = (header, item) => {
              const validated = (item[header.value] || !this.filtersModels[el.value])
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        
          default:
            this.headersData[ixH].filterItems =  [ ...new Set(this.computedItemsProcessed.map(x => x[el.value])) ]
            this.headersData[ixH].filter = (header, item) => {
              if (!this.filtersModels[el.value])
                return true
              if (this.filtersModels[el.value].length === 0)
                return true

              const validated = this.filtersModels[el.value].findIndex(n => n == item[header.value]) > -1
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        }
      })
      
      filters.push({
        filterType: 'switch',
        filterLabel: 'Com erro',
        value: 'invalidItem',
        disabled: this.readonly
      })
      if (this.props.tableSA7 && this.props.tableSA7ShowAll) {
        filters.unshift({
          filterType: 'switch',
          filterLabel: 'Itens do Cliente',
          value: 'filterSA7',
          hide: this.readonly,
          disabled: this.computedItemsProcessed.filter(this.filterItems).length > 0 && !this.filtersModels.filterSA7
        })
      }
      return filters
    },
    totalize() {
      let totalize = null;

      if (this.computedItemsProcessed && this.computedItemsProcessed.length > 0) {
        totalize = [];
        this.computedHeadersData
          .filter((x) => x.totalize)
          .forEach((elx) => {
            const total = this.computedItemsProcessed
              .map((x) => (x[elx.value]*1))
              .reduce((acc, cur) => acc + cur);
            const prefix = elx.prefix ? elx.prefix + " " : "";
            const suffix = elx.suffix ? " " + elx.suffix : "";
            totalize.push({
              label: elx.text,
              mobile: elx.mobile,
              text:
                prefix +
                total.toLocaleString("pt-br", {
                  minimumFractionDigits: elx.precisionText,
                  maximumFractionDigits: elx.precisionText,
                }) +
                suffix,
              value: elx.value,
            });
          });
      }
      return totalize;
    },
    isSearched() {
      return (this.search && this.search.value)
    },
    isFiltered() {
      if (this.search.value.length > 0)
        return true
      
      return Object.entries(this.filtersModels)
        .some(([_, model]) => {
          if (Array.isArray(model) && model.length > 0)
            return true
          if (typeof model == "boolean" && model)
            return true
          return false
        })
    },
    computedItems() {
      const someItemExpanded = this.computedItemsProcessed.some(i => i.show)
      const filters = Object.entries(this.filtersModels).filter(([key,value]) => Array.isArray(value) && value.length === 0 ? false : true).map(([key, value]) =>  ({header: key, value}) )
      
      const itemsShowed = this.computedItemsProcessed.filter(i => i.show || !someItemExpanded)
      return (!this.isFiltered) ? itemsShowed : itemsShowed.filter(i => {
        const validFilters = filters.every(f => {
          if (typeof f.value === 'boolean') {
            if (f.value && f.header == "filterSA7") { 
              return !i.A7_YINCLUIR
            } 
            return !f.value || i[f.header]
          } else if (typeof i[f.header] === 'undefined') { 
            return true
          } else {
            return f.value.some(filter => (filter+'').trim().toLowerCase() === (i[f.header]+'').trim().toLowerCase())
          }
        })
        const searcher = this.headersMobile.map(hm => (i[hm.value] + '').toLowerCase().trim()).join('')
        return validFilters && searcher.includes(this.search.value.toLowerCase().trim())
      })
    },
    validated() {
      return !(this.computedItemsProcessed.filter(i => i.invalidItem).length > 0) && this.computedItemsProcessed.filter(this.filterItems).length > 0
    },
  },
  watch: {
    items(newValue) {
      this.computeItems()
    },

    'filtersModels.filterSA7'(newValue) {
      this.$emit("filterSA7", newValue);
    },

    SA7off(newValue) {
      this.filtersModels.filterSA7 = !newValue
    },
  },
  setup() {
    return {
      chevronDown,
      chevronUp,
      close,
      checkmarkOutline,
      addOutline,
      removeOutline
    };
  },
  data() {
    return {
      editing: null,
      editItem: {},
      editItemBollean: false,
      itemsProcessed: [],
      quantity: 0,
      imageHeader: {},
      titleHeader: {},
      subTitleHeader: {},
      allHeaders: [],
      errorMessages: [],
      headersData: [],
      loadingItems: true,
      // loadedItems: [],
      showItems: false,
      isDisabled: false,
      maxLoadedItems: 20,
      invalidItems: [],
      search: {
        value: "",
      },
      filtersModels: {
        invalidItem: false,
        filterSA7: this.props.tableSA7,
      },
    };
  },
  created() {
    this.headersData = this.headers
    this.computeItems()
    // this.pushData()
    this.fetchFiltersCollections()
    this.titleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "title"
    );
    this.subTitleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "subTitle"
    );
    this.imageHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "images"
    ) || {};
    this.allHeaders = this.headersMobile
      .filter((hm) => hm.mobile.type === "all")
      .sort((h1, h2) => {
        if (h1.mobile.horizontalPosition > h2.mobile.horizontalPosition)
          return 1;
        if (h1.mobile.horizontalPosition < h2.mobile.horizontalPosition)
          return -1;
        return 0;
      });
  },
};
</script>

<style scoped>
  .row-margin-bottom {
    margin-bottom: 8px;
  }
  .invalid-item, .invalid-header {
    border: 1pt solid var(--ion-color-danger);
  }
  .warned-item, .warned-header {
    border: 1pt solid var(--ion-color-warning);
  }
  .invalid-header *:not(ion-button, ion-icon) {
    color: var(--ion-color-danger)
  }
  .info-item, .info-header {
    border: 1pt solid var(--ion-color-tertiary-tint);
  }
  .box {
    border-color: rgba(0, 0, 0, 0.2);
    border-width: thin;
    border-style: solid;
    border-radius: .5em;
    padding: 0;
    margin: 0 10px 10px;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    font-family: Open Sans,sans-serif!important;
    color: rgba(0, 0, 0, 0.671);
  }
</style>